import { render, staticRenderFns } from "./SavedResearchAssistList.vue?vue&type=template&id=5b20e704&"
import script from "./SavedResearchAssistList.vue?vue&type=script&lang=js&"
export * from "./SavedResearchAssistList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports